import { axiosApi } from "../axios";
import { AxiosResponse } from "axios";
import { MessageAnalysisResponse } from "../types/messages";
import { CheckboxAnalysis } from "../containers/AppContainer/AppContainer";
// import { translateToImmutableId } from "./file";

export const getMessageAnalysis = async (itemId: string, userId: string): Promise<MessageAnalysisResponse> => {
  // TEMP-DEMO-LOG: remove once done testing immutable ids
  // translateToImmutableId(itemId).then((id) => console.log("Immutable id:", id)).catch(() => {});

  const response = await axiosApi.get<MessageAnalysisResponse>(`/users/${userId}/messages/${itemId}`);

  return response.data;
};

export const saveMessageAnalysis = async (
  checkboxes: CheckboxAnalysis
): Promise<AxiosResponse<MessageAnalysisResponse>> => {
  const body = [];

  const attachmentsIds = checkboxes
    .map((item) => item.id)
    .filter((value, index, self) => {
      return self.indexOf(value) === index;
    });

  attachmentsIds.forEach((id) => {
    const mutations = checkboxes.filter((checkbox) => {
      return checkbox.id === id;
    });

    const newAttachement: { [key: string]: string } = {
      attachmentId: id,
    };

    mutations.forEach((mutation) => {
      if (mutation.type === "attach") {
        newAttachement.attachmentSaveType = "newVersion";
      }
      if (mutation.type === "compare") {
        newAttachement.comparisonSaveType = "newVersion";
      }
      if (mutation.type === "new") {
        newAttachement.attachmentSaveType = "newDocument";
      }
      if (mutation.type === "compareNewDocument") {
        newAttachement.comparisonSaveType = "newDocument";
      }
    });

    body.push(newAttachement);
  });

  return axiosApi.post<MessageAnalysisResponse>("/save", body);
};
